import { onMounted } from 'vue';

// 解决 IOS 微信浏览器外跳回退不刷新，history 回退异常
export const usePageChangeVisible = () => {
  onMounted(async () => {
    let isPageHide = false;

    window.addEventListener('pageshow', function () {
      const isUpdate = localStorage.getItem('isUpdate');
      if (isPageHide && isUpdate) {
        window.location.reload();
        localStorage.removeItem('isUpdate');
      }
    });

    window.addEventListener('pagehide', function () {
      isPageHide = true;
    });
  });
};
